export const insuranceCompanies = [
    'AARP',
    'Aetna',
    'American Family Insurance',
    'American National Insurance',
    'Amerigroup',
    'Anthem',
    'Bankers Life and Casualty',
    'Blue Cross and Blue Shield',
    'Cambia Health Solutions',
    'CareSource',
    'Centene Corporation',
    'Cigna',
    'Conseco',
    'Coventry Health Care',
    'Delta Dental',
    'EmblemHealth',
    'Fidelis Care',
    'Fortis',
    'Geisinger',
    'Golden Rule Insurance Company',
    'Group Health Cooperative',
    'Group Health Incorporated',
    'Harvard Pilgrim Health Care',
    'Health Net',
    'HealthMarkets',
    'HealthPartners',
    'HealthSpring',
    'Highmark',
    'Horace Mann Educators Corp',
    'Humana',
    'Independence Blue Cross',
    'Kaiser Permanente',
    'Kaleida Health',
    'Liberty Medical',
    'LifeWise Health Plan of Oregon',
    'MassHealth',
    'Medica',
    'Medicare',
    'Medicaid',
    'Medical Mutual of Ohio',
    'MEGA Life and Health Insurance',
    'Molina Healthcare',
    'Mutual of Omaha',
    'Oscar Health',
    'Oxford Health Plans',
    'Premera Blue Cross',
    'Principal Financial Group',
    'Shelter Insurance',
    'State Farm',
    'Thrivent Financial for Lutherans',
    'United American Insurance',
    'UnitedHealth Group',
    'Unitrin',
    'Universal American Corporation',
    'US Health Group',
    'Vantage Health Plan',
    'Wellcare',
]